import { Component, Renderer2, ViewChild, ElementRef, OnInit, ViewChildren, QueryList} from '@angular/core';
import { AuthService } from './auth/auth.service';

import { publicMenuList, areeTematiche } from './menu';

declare var $: any;
declare function trackMenu(): any;


/**
 * @title Nested sidemenu
 */
@Component({
  selector: 'nested-sidemenu',
  templateUrl: 'sidemenu.html',
  styleUrls: ['./sidemenu.css']
})
export class NestedSidemenu implements OnInit {
  menuList: Array<any>;

  constructor(private ren: Renderer2, private authService: AuthService) {
	if(authService.isUserAuthenticated()) {
		this.menuList = authService.getMenu();
		this.menuList.unshift({ label: 'HOME PRIVATA', children: [], route: '' });
		
		this.menuList.forEach(menuItem => {
			console.log(menuItem.id);

			if(menuItem.id == 200) {
				this.addChildren2AreaTematiche(areeTematiche, menuItem.children);
			}
		});
	}
	else
		this.menuList = publicMenuList;
  }

  ngOnInit() {
      $('.hamburger-toggle').click(function() {
        $('body,html').animate({scrollTop:0},200);
        $('body').toggleClass('main-menu-opened');
        $('#block-menu-hamburger').toggleClass('active', 1000);
        $('#overlayer').toggleClass('forceVisibility', 100);
      });
      $('#hamburger-close').on('click',function(e){
        e.preventDefault();
        $('body').toggleClass('main-menu-opened');
        $('#block-menu-hamburger').toggleClass('active', 1000);
        $('#overlayer').toggleClass('forceVisibility', 100);
      });          

      setTimeout(function () {
          $('.accordion-toggle').on('click',function(){
              if ( $(this).hasClass('active') ){
                  $(this).removeClass('active');
                  $(this).removeClass('expanded');
                  $(this).addClass('collapsed');
                  $(this).children().addClass('fa-angle-down');
                  $(this).children().removeClass('fa-angle-up');
                  $('.accordion-toggle').siblings().hide();
              } else {
                  $('.accordion-toggle').removeClass('active');
                  $(this).addClass('active');
                  $('.accordion-toggle').siblings().hide();
                  $(this).removeClass('collapsed');
                  $(this).addClass('expanded');
                  $('.accordion-toggle').children().removeClass('fa-angle-up');
                  $('.accordion-toggle').children().addClass('fa-angle-down');
                  $(this).children().removeClass('fa-angle-down');
                  $(this).children().addClass('fa-angle-up');
                  $(this).siblings().slideToggle();
              }
          });

          $('.sidemenu-limenuitem').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('main-menu-opened');
            $('#block-menu-hamburger').toggleClass('active', 1000);
            $('#overlayer').toggleClass('forceVisibility', 100);
          });
            
      }, 500);

}

  addChildren2AreaTematiche(menuArr, children) {
    if(children && children.length) {
      children.forEach(area => {
        if(area.label2) {
          let subarea = [];
          this.addChildren2AreaTematiche(subarea, area.children);

          menuArr.push( {
            "id": area.id,
            "label": area.label,
            "title": area.title,
            "route": area.route,
            "href": area.href,
            "behavior": area.behavior,
            "icon": area.icon,
            "label2": area.label2,
            "title2": area.title2,
            "route2": area.route2,
            "href2": area.href2,
            "behavior2": area.behavior2,
            "icon2": area.icon2,
            "children": subarea
          });
        }
      });
    };
  } 

  gotoPage(ev, where) {
    /*
    if(where&&where.startsWith('http'))
      window.open(where);
    else
    */
      window.location.href = where;
  }

}

